import { useCallback, useContext, useState } from "react";
import { StartPayError } from "../core/errors";
import { StartPayContext } from "../provider/StartPayContext";
import type { PaymentStatusInput, StartPaymentRequest, VerifyPaymentInput } from "../types/payment";

export const useStartPay = () => {
  const context = useContext(StartPayContext);
  const [loading, setLoading] = useState(false);

  if (!context) {
    throw new StartPayError("useStartPay must be used inside StartPayProvider", "PROVIDER_MISSING");
  }

  const { client } = context;

  const startPayment = useCallback(
    async (input: StartPaymentRequest) => {
      setLoading(true);
      try {
        return await client.startPayment(input);
      } finally {
        setLoading(false);
      }
    },
    [client]
  );

  return {
    startPayment,
    verifyPayment: useCallback((input: VerifyPaymentInput) => client.verifyPayment(input), [client]),
    getPaymentStatus: useCallback((input: PaymentStatusInput) => client.getPaymentStatus(input), [client]),
    cancelPayment: useCallback((input: PaymentStatusInput) => client.cancelPayment(input), [client]),
    on: client.on,
    off: client.off,
    loading
  };
};
